import { Component } from '@theme/component';

/**
 * A custom element that applies a parallax effect to its children media elements.
 * 
 * @extends Component
 */
export class HeroParallax extends Component {
  connectedCallback() {
    super.connectedCallback();
    
    this.speed = parseFloat(this.dataset.speed || '0.4');
    this.onScroll = this.onScroll.bind(this);
    
    // Find media items directly for maximum robustness
    this.mediaItems = /** @type {HTMLElement[]} */ (Array.from(this.querySelectorAll('.hero__media')));
    
    console.log('HeroParallax: Initialized', {
      speed: this.speed,
      itemsFound: this.mediaItems.length
    });

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          window.addEventListener('scroll', this.onScroll, { passive: true });
          this.onScroll();
        } else {
          window.removeEventListener('scroll', this.onScroll);
        }
      });
    }, { threshold: 0 });

    this.observer.observe(this);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    if (this.observer) this.observer.disconnect();
  }

  onScroll() {
    if (!this.mediaItems || !this.mediaItems.length) return;

    const rect = this.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    
    // Safety check: if element is far off-screen, ignore
    if (rect.bottom < 0 || rect.top > viewportHeight) return;

    // Calculate normalized progress (0 when top is at bottom of viewport, 1 when bottom is at top of viewport)
    // But simpler: how far is the center of the element from the center of the screen
    const elementCenter = rect.top + rect.height / 2;
    const viewportCenter = viewportHeight / 2;
    const distanceFromCenter = elementCenter - viewportCenter;
    
    const speed = this.speed || 0.4;
    const translateY = (distanceFromCenter || 0) * speed;
    
    requestAnimationFrame(() => {
      const items = this.mediaItems;
      const scale = 1.1 + Math.abs(speed);
      
      if (items) {
        items.forEach(item => {
          if (item instanceof HTMLElement) {
            // Apply the parallax transformation
            item.style.transform = `translate3d(0, ${translateY}px, 0) scale(${scale})`;
          }
        });
      }
    });
  }
}

if (!customElements.get('hero-parallax')) {
  customElements.define('hero-parallax', HeroParallax);
}
